module.exports = __webpack_public_path__ + "img/list25.acb0d05f.jpeg";